/**
 * UI copy for Sunshine Reconciliation Forms (matches portal prototype).
 * Carrier rows + file URLs come from Zoho; contacts can come from API root
 * `contacts` or fall back to DEFAULT_RECONCILIATION_CONTACTS.
 */

export const RECONCILIATION_FORMS_I18N = {
  es: {
    'html.title':
      'Formularios de Reconciliación · Sunshine Life & Health Advisors',
    'nav.instructions': 'Instrucciones',
    'nav.carriers': 'Aseguradoras',
    'nav.email': 'Plantilla de correo',
    'nav.contact': 'Contacto',
    'hero.eyebrow': 'Centro de agentes',
    'hero.title': 'Formularios de Reconciliación por Aseguradora',
    'hero.sub':
      'Acceso centralizado a las plantillas oficiales de reconciliación de comisiones. Descargue, complete y envíe al correo correcto de cada aseguradora.',
    'hero.cta1': 'Ver aseguradoras',
    'hero.cta2': 'Cómo enviar',
    'hero.stat1': 'aseguradoras',
    'hero.stat2': 'con plantilla',
    'hero.cardNote':
      'Solo se aceptan las plantillas oficiales adjuntas. Otros formatos no serán revisados.',
    'instructions.eyebrow': 'Cómo proceder',
    'instructions.title': 'Instrucciones de envío',
    'instructions.lede':
      'Siga estos pasos para asegurar que su reconciliación sea procesada correctamente.',
    'instructions.step1.title': 'Descargue la plantilla',
    'instructions.step1.body':
      'Haga clic en el bloque de la aseguradora para descargar la plantilla oficial desde Zoho.',
    'instructions.step2.title': 'Complete el formulario',
    'instructions.step2.body':
      'Llene todos los campos requeridos en la plantilla de reconciliación. Verifique los datos antes de guardar.',
    'instructions.step3.title': 'Envíe por correo',
    'instructions.step3.body':
      'Haga clic en "Enviar" en la tarjeta de la aseguradora para abrir un correo prellenado al destinatario correcto.',
    'instructions.step4.title': 'Guarde una copia',
    'instructions.step4.body':
      'Recomendamos guardar cada reporte y plantilla por separado por nombre de la compañía, en una carpeta de fácil acceso.',
    'alert.important': 'Importante',
    'alert.importantBody':
      'Solo se aceptarán los formularios de reconciliación adjuntos. No se revisarán otros reportes ni formatos. Use únicamente la plantilla oficial descargada desde Zoho.',
    'carriers.eyebrow': 'Plantillas por aseguradora',
    'carriers.title': 'Aseguradoras',
    'carriers.lede':
      'Haga clic en el área de descarga para obtener la plantilla. Use "Enviar" para abrir un correo prellenado.',
    'carriers.searchPh': 'Buscar aseguradora…',
    'carriers.of': 'de',
    'carrier.download': 'Descargar plantilla',
    'carrier.submit': 'Enviar',
    'carrier.copyEmail': 'Copiar correo',
    'carrier.email': 'Enviar a',
    'carrier.cc': 'CC',
    'carrier.tagExternal': 'Aseguradora',
    'carrier.tagInternal': 'Vía Sunshine',
    'carrier.emailOnlyNote':
      'Esta aseguradora no requiere plantilla descargable. Use "Enviar" para iniciar su correo de reconciliación.',
    'carrier.otherNote':
      'Para cualquier otra aseguradora no listada arriba, contáctenos directamente con sus datos de reconciliación.',
    'email.eyebrow': 'Modelo listo para usar',
    'email.title': 'Plantilla de correo electrónico',
    'email.lede':
      'Esta guía coincide con el correo prellenado al hacer clic en "Enviar". Reemplace los campos en corchetes [ ] con su información.',
    'email.copy': 'Copiar',
    'email.copied': 'Copiado',
    'email.to': 'Para',
    'email.cc': 'CC (siempre)',
    'email.subject': 'Asunto',
    'email.tpl1.title': 'Reconciliación estándar',
    'email.tpl1.to': '[correo de la aseguradora]',
    'email.tpl1.subject':
      'Reconciliación de Comisiones — [Nombre de Aseguradora] — [Mes/Año] — Sunshine Life & Health Advisors',
    'email.tpl1.body': `Estimado equipo de comisiones,

Adjunto el formulario de reconciliación correspondiente al período [Mes/Año] para su revisión y procesamiento.

Por favor confirmen recepción y avísenme si requieren información adicional.

Quedo atenta a su respuesta.

Saludos cordiales,
[Su nombre]
[Su NPN / Producer ID]
[Su correo electrónico]
[Su teléfono]`,
    'email.tpl2.title': 'Seguimiento / recordatorio',
    'email.tpl2.to': '[correo de la aseguradora]',
    'email.tpl2.subject':
      'Seguimiento — Reconciliación [Nombre de Aseguradora] — [Mes/Año]',
    'email.tpl2.body': `Buen día,

Doy seguimiento al envío de la plantilla de reconciliación de [Mes/Año] enviada el [fecha de envío original]. Agradezco confirmación de recepción y estatus de procesamiento.

Si hace falta información adicional, con gusto la proporciono.

Gracias por su atención.

Saludos cordiales,
[Su nombre]
[Su correo electrónico]
[Su teléfono]`,
    'email.community.body': `Estimado equipo de Agent Commissions,

Me dirijo a ustedes para iniciar el proceso de reconciliación de comisiones correspondiente al período [Mes/Año].

Por favor confirmen el formato o reporte requerido por Community Health Choice / Community Cares para procesar esta reconciliación, e indiquen los próximos pasos.

Quedo atenta a su respuesta.

Saludos cordiales,
[Su nombre]
[Su NPN / Producer ID]
[Su correo electrónico]
[Su teléfono]`,
    'email.other.body': `Hola Ricardo y Jennifer,

Necesito ayuda con una reconciliación de comisiones para una aseguradora que no aparece en el listado oficial.

Datos:
- Aseguradora: [Nombre de la Aseguradora]
- Período: [Mes/Año]
- Pólizas / casos en revisión: [detalle]
- Notas adicionales: [cualquier información relevante]

Quedo atenta a sus indicaciones.

Saludos,
[Su nombre]
[Su NPN / Producer ID]
[Su correo electrónico]
[Su teléfono]`,
    'contact.eyebrow': 'Soporte interno',
    'contact.title': '¿Necesita ayuda?',
    'contact.lede':
      'Si tiene preguntas sobre el proceso de reconciliación o no encuentra una aseguradora, contáctenos directamente.',
    'contact.phone': 'Teléfono',
    'footer.copy':
      '© 2026 Sunshine Life & Health Advisors LLC. Todos los derechos reservados.',
    'footer.address':
      '7757 W. Flagler Street, Suite 210 · Miami, FL 33144 · 305.602.0436',
    'footer.internal': 'Documento interno — Solo para agentes autorizados.',
    'toast.copied': 'Correo copiado al portapapeles',
    'toast.copiedTpl': 'Plantilla copiada al portapapeles',
    'toast.copyFail': 'No se pudo copiar',
    'toast.downloading': 'Descargando plantilla…'
  },
  en: {
    'html.title': 'Reconciliation Forms · Sunshine Life & Health Advisors',
    'nav.instructions': 'Instructions',
    'nav.carriers': 'Carriers',
    'nav.email': 'Email Template',
    'nav.contact': 'Contact',
    'hero.eyebrow': 'Agent Center',
    'hero.title': 'Reconciliation Forms by Carrier',
    'hero.sub':
      'Centralized access to official commission reconciliation templates. Download, complete, and send to the correct email for each carrier.',
    'hero.cta1': 'View carriers',
    'hero.cta2': 'How to submit',
    'hero.stat1': 'carriers',
    'hero.stat2': 'with template',
    'hero.cardNote':
      'Only the official attached templates will be accepted. Other formats will not be reviewed.',
    'instructions.eyebrow': 'How to proceed',
    'instructions.title': 'Submission Instructions',
    'instructions.lede':
      'Follow these steps to ensure your reconciliation is processed correctly.',
    'instructions.step1.title': 'Download the template',
    'instructions.step1.body':
      "Click the carrier's download area to get the official template from Zoho.",
    'instructions.step2.title': 'Complete the form',
    'instructions.step2.body':
      'Fill in all required fields on the reconciliation template. Double-check your entries before saving.',
    'instructions.step3.title': 'Send by email',
    'instructions.step3.body':
      'Click "Submit" on the carrier card to open a pre-filled email to the correct recipient.',
    'instructions.step4.title': 'Keep a copy',
    'instructions.step4.body':
      'We recommend saving each report and template separately by carrier name in an easily accessible folder.',
    'alert.important': 'Important',
    'alert.importantBody':
      'Only the attached reconciliation templates will be accepted. No other reports or formats will be reviewed. Use only the official template downloaded from Zoho.',
    'carriers.eyebrow': 'Templates by carrier',
    'carriers.title': 'Carriers',
    'carriers.lede':
      'Click the download area to get the template. Use "Submit" to open a pre-filled email.',
    'carriers.searchPh': 'Search carrier…',
    'carriers.of': 'of',
    'carrier.download': 'Download template',
    'carrier.submit': 'Submit',
    'carrier.copyEmail': 'Copy email',
    'carrier.email': 'Send to',
    'carrier.cc': 'CC',
    'carrier.tagExternal': 'Carrier',
    'carrier.tagInternal': 'Via Sunshine',
    'carrier.emailOnlyNote':
      'This carrier does not require a downloadable template. Use "Submit" to start your reconciliation email.',
    'carrier.otherNote':
      'For any other carrier not listed above, contact us directly with your reconciliation details.',
    'email.eyebrow': 'Ready-to-use template',
    'email.title': 'Email Template',
    'email.lede':
      'This guide matches the pre-filled email when you click "Submit". Replace the bracketed [ ] fields with your information.',
    'email.copy': 'Copy',
    'email.copied': 'Copied',
    'email.to': 'To',
    'email.cc': 'Cc (always)',
    'email.subject': 'Subject',
    'email.tpl1.title': 'Standard reconciliation',
    'email.tpl1.to': '[carrier email]',
    'email.tpl1.subject':
      'Commission Reconciliation — [Carrier Name] — [Month/Year] — Sunshine Life & Health Advisors',
    'email.tpl1.body': `Dear Commissions Team,

Please find attached the reconciliation form for the [Month/Year] period for your review and processing.

Kindly confirm receipt and let me know if any additional information is required.

I look forward to your response.

Best regards,
[Your name]
[Your NPN / Producer ID]
[Your email]
[Your phone]`,
    'email.tpl2.title': 'Follow-up / reminder',
    'email.tpl2.to': '[carrier email]',
    'email.tpl2.subject':
      'Follow-up — Reconciliation [Carrier Name] — [Month/Year]',
    'email.tpl2.body': `Good day,

I am following up on the reconciliation template for [Month/Year] sent on [original send date]. I would appreciate confirmation of receipt and an update on processing status.

If any additional information is needed, I am happy to provide it.

Thank you for your attention.

Best regards,
[Your name]
[Your email]
[Your phone]`,
    'email.community.body': `Dear Agent Commissions team,

I am reaching out to initiate the commission reconciliation process for the [Month/Year] period.

Please confirm the format or report required by Community Health Choice / Community Cares to process this reconciliation, and advise on next steps.

I look forward to your response.

Best regards,
[Your name]
[Your NPN / Producer ID]
[Your email]
[Your phone]`,
    'email.other.body': `Hi Ricardo and Jennifer,

I need help with a commission reconciliation for a carrier not listed on the official page.

Details:
- Carrier: [Carrier Name]
- Period: [Month/Year]
- Policies / cases under review: [detail]
- Additional notes: [any relevant info]

Awaiting your guidance.

Best,
[Your name]
[Your NPN / Producer ID]
[Your email]
[Your phone]`,
    'contact.eyebrow': 'Internal support',
    'contact.title': 'Need help?',
    'contact.lede':
      'If you have questions about the reconciliation process or cannot find a carrier, contact us directly.',
    'contact.phone': 'Phone',
    'footer.copy':
      '© 2026 Sunshine Life & Health Advisors LLC. All rights reserved.',
    'footer.address':
      '7757 W. Flagler Street, Suite 210 · Miami, FL 33144 · 305.602.0436',
    'footer.internal': 'Internal document — For authorized agents only.',
    'toast.copied': 'Email copied to clipboard',
    'toast.copiedTpl': 'Template copied to the clipboard',
    'toast.copyFail': 'Could not copy',
    'toast.downloading': 'Downloading template…'
  }
};

export function t(lang, key) {
  const bundle =
    RECONCILIATION_FORMS_I18N[lang] || RECONCILIATION_FORMS_I18N.es;
  return bundle[key] ?? key;
}

/** Fallback when Zoho response does not include `contacts`. */
export function getDefaultSupportContacts(lang) {
  return [
    {
      type: 'email',
      name: 'Jennifer',
      email: 'jennifer@sunshinelifehealth.com'
    },
    { type: 'email', name: 'Ricardo', email: 'ricardolivingsecure@gmail.com' },
    {
      type: 'phone',
      name: t(lang, 'contact.phone'),
      tel: '+13056020436',
      display: '305.602.0436'
    }
  ];
}
